import { useList } from "@inmagik/react-crud"
import type { Municipality } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi, normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useMunicipalitiesList(params: Record<string, string> = {}) {
  return useList<Municipality>(`${API_URL}/admin/municipalities`, {
    query: params,
  })
}

export function useMunicipalityLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/municipalities/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Municipality>
  }, [])
}

export function useMunicipalitiesLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/municipalities?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Municipality[] }>
  }, [])
}
